import type { TicketEstatus, TicketPrioridad } from './types.js';

// SRS-02 §14.1/14.2 — clases copiadas tal cual en globals.css. Se combinan
// con la clase compartida `.badge` (forma/tamaño) que ya usa el resto de la
// app, igual que `badge badge-success` etc. — las clases del SRS solo aportan
// la paleta de color exacta pedida.

const PRIORIDAD_LABEL: Record<TicketPrioridad, string> = {
  P1: 'P1 Urgente',
  P2: 'P2 Normal',
  P3: 'P3 Programable',
};

const PRIORIDAD_CLASS: Record<TicketPrioridad, string> = {
  P1: 'prio-p1',
  P2: 'prio-p2',
  P3: 'prio-p3',
};

export function PrioridadBadge({ prioridad }: { prioridad: TicketPrioridad }) {
  return <span className={`badge ${PRIORIDAD_CLASS[prioridad]}`}>{PRIORIDAD_LABEL[prioridad]}</span>;
}

const ESTATUS_LABEL: Record<TicketEstatus, string> = {
  nueva:       'Nueva',
  en_progreso: 'En progreso',
  resuelta:    'Resuelta',
  reabierta:   'Reabierta',
  cancelada:   'Cancelada',
};

const ESTATUS_CLASS: Record<TicketEstatus, string> = {
  nueva:       'tk-nueva',
  en_progreso: 'tk-progreso',
  resuelta:    'tk-resuelta',
  reabierta:   'tk-reabierta',
  cancelada:   'tk-cancelada',
};

export function EstatusBadge({ estatus }: { estatus: TicketEstatus }) {
  return <span className={`badge ${ESTATUS_CLASS[estatus]}`}>{ESTATUS_LABEL[estatus]}</span>;
}
